import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=4d620ec8&"
import script from "./FormGroup.vue?vue&type=script&lang=js&"
export * from "./FormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports